// utils/showToast.ts
import i18n from "../i18n";

export function showToast(message: string, type: 'success' | 'error' | 'info' = 'info') {
  // Create wrapper
  const popup = document.createElement("div");
  popup.textContent = message;

  // Color scheme based on type
  const colors = {
    success: "#4caf50", // green
    error: "#f44336",   // red
    info: "#2196f3"     // blue
  };

  // Basic styling – matching logout toast position
  Object.assign(popup.style, {
    position: "fixed",
    top: "20px",
    left: "50%",
    transform: "translateX(-50%)",
    padding: "12px 20px",
    background: colors[type],
    color: "#fff",
    fontFamily: "sans-serif",
    fontSize: "14px",
    borderRadius: "6px",
    boxShadow: "0 2px 6px rgba(0,0,0,.25)",
    zIndex: "9999",
    opacity: "0",
    transition: "opacity 0.25s ease",
  });

  document.body.appendChild(popup);

  // Fade in
  requestAnimationFrame(() => (popup.style.opacity = "1"));

  // Remove after 3 seconds
  setTimeout(() => {
    popup.style.opacity = "0";
    popup.addEventListener("transitionend", () => popup.remove());
  }, 3000);
}
